import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const projects = [
  {
    id: 12,
    title: 'Solune',
    category: 'E-Commerce',
    iconName: 'ShoppingBag',
    views: '18.7k',
    likes: '4.3k',
    img: 'https://cdn.jiro.build/Natural%20Glow/Images/Header%20sm%20image.png',
    url: '/portfolio/solune',
    internal: true
  },
  {
    id: 11,
    title: 'PayUp',
    category: 'Web Development',
    iconName: 'CreditCard',
    views: '45.2k',
    likes: '12.4k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1784140732/CleanShot_2026-07-16_at_02.38.34_2x_ohclq5.png',
    url: '/portfolio/payup',
    internal: true
  },
  {
    id: 10,
    title: 'Echox',
    category: 'E-Commerce',
    iconName: 'Speaker',
    views: '32.4k',
    likes: '8.9k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783999246/CleanShot_2026-07-14_at_11.20.35_2x_m1kjan.png',
    url: '/portfolio/echox',
    internal: true
  },
  {
    id: 9,
    title: 'Laounge Coffee',
    category: 'Web Development',
    iconName: 'Coffee',
    views: '24.1k',
    likes: '5.6k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783997654/CleanShot_2026-07-14_at_10.53.49_2x_mqbawm.png',
    url: '/portfolio/cafe',
    internal: true
  },
  {
    id: 1,
    title: 'FitPair',
    category: 'Mobile Apps',
    iconName: 'Smartphone',
    views: '12.5k',
    likes: '2.4k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783605515/CleanShot_2026-07-09_at_21.43.51_2x_hpzzjx.png',
    url: 'https://fit-pair.com',
    internal: false
  },
  {
    id: 2,
    title: 'Ceylanthro',
    category: 'E-Commerce',
    iconName: 'ShoppingCart',
    views: '18.2k',
    likes: '3.1k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1780166898/Logo_Square_2x_rmw834.png',
    url: 'https://ceylanthro.com/',
    internal: false
  },
  {
    id: 3,
    title: 'Maison De Charm',
    category: 'Web Development',
    iconName: 'Layout',
    views: '9.3k',
    likes: '1.8k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783615207/CleanShot_2026-07-10_at_00.39.50_2x_rdb8kq.png',
    url: 'https://maisondecharm.com',
    internal: false
  },
  {
    id: 4,
    title: 'Alpha Training Consultancy',
    category: 'Web Development',
    iconName: 'Globe',
    views: '15.1k',
    likes: '4.2k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783618134/CleanShot_2026-07-10_at_01.28.37_2x_ium9kt.png',
    url: 'https://alphatcsg.com',
    internal: false
  },
  {
    id: 5,
    title: 'White Knight Global Consultancy',
    category: 'Web Development',
    iconName: 'Shield',
    views: '11.8k',
    likes: '3.6k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783617519/CleanShot_2026-07-10_at_01.18.19_2x_lpodla.png',
    url: 'https://whiteknightgc.com',
    internal: false
  },
  {
    id: 6,
    title: 'Roaming Logos',
    category: 'Web App',
    iconName: 'Navigation',
    views: '8.4k',
    likes: '1.2k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1779211733/Remove_Background_e9npzp.png',
    url: 'https://roaminglogos.com/',
    internal: false
  },
  {
    id: 8,
    title: 'BookOTG',
    category: 'Mobile Apps',
    iconName: 'Book',
    views: '22.4k',
    likes: '5.1k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783618646/CleanShot_2026-07-10_at_01.37.01_2x_m2zyxl.png',
    url: 'https://bookotg.com',
    internal: false
  },
  {
    id: 13,
    title: 'Leopard Bliss Yala',
    category: 'Web Development',
    iconName: 'Globe',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.51.46-AM2x.png',
    url: 'https://leopardblissyala.com',
    internal: false
  },
  {
    id: 14,
    title: 'Zevi.lk',
    category: 'E-Commerce',
    iconName: 'ShoppingCart',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.53.55-AM2x.png',
    url: 'https://zevi.lk',
    internal: false
  },
  {
    id: 15,
    title: 'dat.hostfig.com',
    category: 'Web Development',
    iconName: 'Globe',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.55.26-AM2x.png',
    url: 'https://dat.hostfig.com',
    internal: false
  },
  {
    id: 16,
    title: 'dekka.lk',
    category: 'E-Commerce',
    iconName: 'ShoppingCart',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.56.21-AM2x.png',
    url: 'https://dekka.lk',
    internal: false
  },
  {
    id: 17,
    title: 'kandsons.hostfig.com',
    category: 'Web Development',
    iconName: 'Globe',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.57.37-AM2x.png',
    url: 'https://kandsons.hostfig.com',
    internal: false
  },
  {
    id: 18,
    title: 'otterworks.hostfig.com',
    category: 'Web Development',
    iconName: 'Globe',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.58.36-AM2x.png',
    url: 'https://otterworks.hostfig.com',
    internal: false
  },
  {
    id: 19,
    title: 'paraadventures.com',
    category: 'Web Development',
    iconName: 'Globe',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-11.03.57-AM2x.png',
    url: 'https://paraadventures.com',
    internal: false
  }
];

const categories = ['All', 'Web Development', 'E-Commerce', 'Mobile Apps', 'Web App'];

const PortfolioPage = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredProjects = projects.filter(
    (p) => activeCategory === 'All' || p.category === activeCategory
  );

  const handleProjectClick = (project) => {
    if (project.internal) {
      navigate(project.url);
    } else {
      window.open(project.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="w-full min-h-screen bg-slate-50 pt-32 pb-24 px-6 md:px-12 lg:px-24 font-sans">
      <div className="max-w-[1248px] mx-auto mb-12 md:mb-16 flex flex-col lg:flex-row lg:items-end justify-between gap-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="flex flex-col gap-3 md:gap-4"
        >
          <h1 className="text-slate-900 text-[36px] sm:text-[48px] md:text-[64px] font-bold leading-[1.2] md:leading-[1.1] tracking-[-1px] md:tracking-[-1.8px] flex items-center flex-wrap gap-x-2 md:gap-x-3">
            Our{' '}
            <span className="relative inline-block px-2 md:px-3 py-1">
              <span className="absolute inset-0 bg-blue-100/50 rounded-lg -z-10 transform -rotate-1"></span>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 relative z-10">
                Work
              </span>
            </span>
          </h1>
          <p className="text-slate-600 text-[16px] md:text-[20px] font-normal max-w-xl">
            Explore our complete portfolio of digital experiences engineered for growth, scale, and conversion.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          className="flex flex-col sm:flex-row items-start sm:items-center gap-4"
        >
          <div className="flex bg-white border border-slate-200 p-1 rounded-xl w-full sm:w-auto overflow-x-auto shadow-sm hide-scrollbar">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`flex items-center gap-2 px-4 py-2 text-xs md:text-sm font-semibold transition-all duration-300 rounded-lg whitespace-nowrap ${
                  activeCategory === cat
                    ? 'bg-slate-900 text-white shadow-sm'
                    : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </motion.div>
      </div>

      <div className="max-w-[1248px] mx-auto">
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[40px] md:gap-y-[48px] gap-x-[24px]">
          <AnimatePresence mode="popLayout">
            {filteredProjects.map((project, index) => (
              <motion.div
                key={project.id}
                layout
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.4, delay: (index % 6) * 0.05, ease: "easeOut" }}
                className="cursor-pointer group flex flex-col gap-[16px] md:gap-[20px]"
                onClick={() => handleProjectClick(project)}
              >
                <div className="w-full h-[240px] sm:h-[280px] border border-slate-200 rounded-2xl overflow-hidden relative shadow-sm bg-white">
                  <img
                    src={project.img}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 border border-black/5 rounded-2xl pointer-events-none"></div>
                  <div className="absolute inset-0 bg-slate-900/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <div className="bg-white/90 backdrop-blur-sm text-slate-900 font-bold px-6 py-2 rounded-full transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 shadow-lg">
                      View Project
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-[12px] md:gap-[16px] px-1 md:px-2">
                  <div className="w-12 h-12 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center border border-blue-100 shrink-0 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
                    <SafeIcon name={project.iconName} className="w-5 h-5" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-slate-900 text-[18px] md:text-[20px] font-bold leading-[1.4] line-clamp-1 group-hover:text-blue-600 transition-colors duration-300">
                      {project.title}
                    </h3>
                    <div className="flex items-center gap-3 mt-1 text-slate-400 text-xs">
                      <span>{project.category}</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  );
};

export default PortfolioPage;